import { Modal } from "antd";
import { WeatherTable } from "./WeatherTable";
import { audioNotification } from "../Common/Notifications/audioNotification";

export const WeatherDialog = ({
  open,
  onCancel,
  dateRange,
  onSubmit,
  dateRangeWeather,
  setDateRangeWeather
}) => {
  console.log(dateRange, dateRangeWeather);
  const modalTitle = 'Weather Data Entry';

  const handleSubmit = (weatherData) => {
    onSubmit(weatherData);
    // onCancel();
  };

  const handleCancel = () => {
    // Show notification that weather data hasn't been uploaded
    audioNotification.warning({
      message: 'Weather Data Not Uploaded',
      description: 'No weather data has been uploaded for the selected date range.',
      duration: 4.5
    });
    // Redirect to upload-data path
    onSubmit([]);
  };

  return (
    <Modal
      open={open}
      title={modalTitle}
      onCancel={handleCancel}
      footer={null}
      width={1000}
      style={{ top: 120 }}
    >
      <div className="weather-table-container">
        <WeatherTable 
          dates={dateRange}
          dateRangeWeather={dateRangeWeather}
          setDateRangeWeather={setDateRangeWeather}
          onSubmit={handleSubmit}
        />
      </div>
    </Modal>
  );
}; 